import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError, pipe } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AuthenticationService } from '../../core/services/authentication.service';
import { GenericService } from '@app/core/services/generic.service';

import { Dependente, Loading } from '@app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class DependenteService extends GenericService<any> {

  constructor(http: HttpClient, private auth: AuthenticationService) {
    super('censo/autoAtendimento', http);
  };

  get idAutoAtendimento(): number {
    return this.auth.currentUserValue.idAutoAtendimento;
  }

  get apiBase(): string {
    return `${this.api}/${this.idAutoAtendimento}`;
  }

  get(loading?: Loading): Observable<Dependente[]>{
    this.startLoading(loading);
    return this.getHttpClient().get<Dependente[]>(`${ this.apiBase }/dependentes`)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  post(value: Dependente, loading?: Loading): Observable<Dependente> {
    this.startLoading(loading);
    return this.getHttpClient().post(`${ this.apiBase }/dependentes`, value)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  put(value: Dependente, loading?: Loading): Observable<Dependente> {
    this.startLoading(loading);
    return this.getHttpClient().put(`${ this.apiBase }/dependentes/${value.id}`, value)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  delete(id: number, entity: any, loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().put(`${ this.apiBase }/dependentes/${id}/excluir`, entity)
    .pipe(this.configMapAndLoading(loading));
  }

  result(): any{
    return pipe(
      map((res: any) => res),
      catchError((err: any) => throwError({ message: err })));
   }

  postOrPut(value: Dependente): Observable<Dependente> {
    if (!value.id) {
      return this.post(value);
    } else {
      return this.put(value);
    }
   }
}
